export const JOB_STATUSES = {
    OPEN:   'open',
    DRAFT:   'draft',
    ACTIVE: 'active',
    ARCHIVED:   'archived'
 }